import SLSParametrosService from '@/services/SistemaDKP/SLSParametros.service';

function extractValue(res) {
  if (!res) return null;
  if (typeof res === 'string') return res;
  if (Array.isArray(res)) return extractValue(res[0]);
  if (typeof res === 'object') {
    return (
      res.valor
      || res.value
      || res.parametroValor
      || res.parametro_valor
      || res.url
      || res.URL
      || res.parametro
      || null
    );
  }
  return null;
}

export async function getParametro(paramName) {
  try {
    const svc = new SLSParametrosService();
    const data = await svc.findByDescricao(paramName, true);
    const val = extractValue(data);
    return val;
  } catch (e) {
    return null;
  }
}

export async function getTotvsBaseUrl(modeOverride) {
  const mode = modeOverride || process.env.VUE_APP_MODE_APP || 'development';
  const isProd = String(mode).toLowerCase() === 'production';
  const paramKey = isProd ? 'TOTVS_API_URL_PROD_BACKEND' : 'TOTVS_API_URL_HOMOL';

  const dbUrl = await getParametro(paramKey);
  if (dbUrl) {
    return dbUrl;
  }

  throw new Error(`URL TOTVS não configurada para este tenant: ${paramKey}.`);
}
